<template>
  <div class="container container-login">
    <div class="d-flex justify-content-center h-100 main-login">
      <div class="user_card">
        <div class="login-detail">
          <div class="d-flex justify-content-center image-forgot">
            <div class="image-detail">
              <div class="logo-login">
                <img src="./Rectangle.png" class="brand_logo" alt="Logo" />
              </div>
            </div>
          </div>
          <div>
            <h3 class="style-login">{{ $t("commons.button.login") }}</h3>
          </div>

          <div class="d-flex justify-content-center form_container" >
            <ValidationObserver v-slot="{ handleSubmit }" class="form-login"  style="background-color:white !important;">
              <form @submit.prevent="handleSubmit(loginUser)" class="login-details" style="background-color:white !important;" novalidate>
                <ValidationProvider
                        :name="$t('user_problem.label.username')"
                        rules="min:6|required"
                        v-slot="{ errors }"
                        style="background-color:white !important;"
                >
                      <div >
                          <p class="title-inpput required">{{$t('user_problem.label.username')}}</p>
                      </div>

                      <div class="style-form">
                        <input
                                type="text"
                                :maxlength="256"
                                :minlength="6"
                                required
                                class="form-control input_user custom-input  input-login"
                                :placeholder="$t('user_problem.label.username')"
                                v-model.trim="user_name"
                        >
                      </div>
                    <span class="text-danger"> {{ errors[0] ? $t('user_problem.label.user_minimum') : null }} </span>
                </ValidationProvider>
                <ValidationProvider
                  :name="$t('commons.label.password')"
                  rules="required|min:6"
                  v-slot="{ errors }"
                >
                    <div class="form-input">
                      <p class="title-inpput required">{{$t('commons.label.password')}}</p>
                      <div class="style-form">
                          <input
                              :type="typePasswordChange"
                              :maxlength="256"
                              class="form-control input_user custom-input input-login"
                              :placeholder="$t('commons.label.password')"
                              v-model="password"
                              style="width: 100%"
                          >
                          <div @click="changeConfirmPassword()" class="hide-password">
                            <ion-icon v-if="eyeHide" name="eye-outline" class="icon-eye-login"></ion-icon>
                            <ion-icon v-if="eyeShow" name="eye-off-outline" class="icon-eye-login"></ion-icon>
                          </div>
                      </div>
                        <span class="text-danger"> {{ errors[0] ? $t('user_problem.label.password_minimum') : null }} </span>
                    </div>

                </ValidationProvider>

                <div class="login-style">
                  <div class="d-flex justify-content-center login_container">
                      <button type="submit" name="button" class="btn login_btn primary">
                          <div>{{ $t("commons.button.login") }}</div>
                      </button>
                     <!-- <router-link :to="{ name: 'TeacherList' }" tag="a" class="btn login_btn">
                        <div> {{ $t("commons.button.login") }} </div>
                      </router-link> -->
                  </div>
                  <div class="forgot-password">
                    <div class="d-flex justify-content-center links ">
                      <router-link :to="{ name: 'Forgot' }" tag="a" class="forgot-password">{{
                        $t("commons.label.forgot_password")
                      }}</router-link>
                    </div>
                  </div>
                </div>
              </form>
            </ValidationObserver>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "../plugins/axios";
import Cookies                                  from "js-cookie";
import { mapActions } from "vuex";
import { ValidationObserver, ValidationProvider } from "vee-validate";
export default {
  name: "Login",
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.from = from;
    });
  },
  data() {
    return {
        typePasswordChange: "password",
        eyeHide: false,
        eyeShow: true,
        user_name: "",
        password: "",
        from: null
    };
  },
   async created() {

      const ticket = new URLSearchParams(window.location.hash.slice(1)).get("workspace_ticket");
      window.history.replaceState(null, null, window.location.pathname);
      Cookies.remove("rsr-user-token");
      Cookies.remove("student-permissions");
      if (ticket) {
        this.$root.$loading.start();
        try {
          const {data} = await axios.post("auth/workspace-login", {ticket});
          this.$store.commit("auth/login", data);
          await this.$router.replace({name: "ExamList"});
        } catch (error) {
          this.$root.toast(this.$t("commons.label.login_error"), "danger", this.$t("commons.message.wrong_password_username"));
        } finally { this.$root.$loading.finish(); }
      }
    },
  methods: {
    ...mapActions("auth", ["login"]),
    changeConfirmPassword(){
        if(this.typePasswordChange === "text"){
          this.typePasswordChange = "password";
          this.eyeHide = false;
          this.eyeShow  = true;
        }
        else if(this.typePasswordChange === "password") {
          this.typePasswordChange ="text";
          this.eyeHide  = true;
          this.eyeShow  = false;
        }
    },
    async loginUser() {
      var str= this.user_name.trim();

        const params = {
          user_name: str,
          password: this.password,
        };
        this.$root.$loading.start();
        await this.login(params);
        // if(this.$store.state.auth.loginRes == "200"){
        //     this.$root.toast(
        //         this.$t("commons.label.create_success_title"),
        //         "danger",
        //         this.$t(`msg["C_UC1_01"]`)
        //     );
        // }
        this.$root.$loading.finish();
        if (this.$store.state.auth.loginRes.code === "4000") {
            this.$root.toast(
                this.$t("commons.message.send_fail"),
                "danger",
                this.$t("commons.message.wrong_password_username")
            );
        } else if (this.$store.state.auth.loginRes.message === "E_UC1_49") {
            this.$bvToast.toast(
                this.$t(`msg["E_UC1_49"]`),
                {
                    title: this.$t("difficulty.notice"),
                    autoHideDelay: 5000,
                    variant: "danger"
                }
            );
        } else if (this.$store.state.auth.loginRes.status === 200) {
            if (this.from.name === 'Signup' || this.from.name === 'ResetPassword' || this.from.name === 'Forgot') {
                this.$router.push({name: "Home"});
            } else {
                this.$router.push({name: "TeacherList"});
            }
        } else {
            this.$root.toast(
                this.$t("commons.label.login_error"),
                "danger",
                this.$t("commons.message.wrong_password_username")
            );
        }
      }
    }
};
</script>

<style scoped>
p{
  margin-bottom:0px;
}
.container-login {
  display: flex;
  justify-content: center;
  align-content: center;
  height: 100vh;
  background: #E5EAFF !important;
  width: 100%;
}
.main-login{
  width: 100%;
}
.user_card {
  height:80%;
  width: 51%;
  margin-top: auto;
  margin-bottom: auto;
  background: #FFFFFF;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  border-radius: 14px;
}

.brand_logo_container {
  position: absolute;
  height: 170px;
  width: 170px;
  top: -75px;
  border-radius: 50%;
  background: #60a3bc;
  padding: 10px;
  text-align: center;
}

.form_container {
  /* margin-top: 6%; */
  width: 100%;
  height:36%;
  position: relative;
}
.login_btn {
  width: 100%;
  background: #6674BB;
  border-radius: 8px;
}

.login_btn:hover {
    box-shadow: 0px 8px 26px 1px rgba(0, 0, 0, 0.3);
}

.login_btn.btn.disabled, .btn:disabled {
    background-color: #c4c4c4
}

.login_btn div{
  font-family: Roboto;
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 28px;
  text-align: center;
  letter-spacing: -0.015em;
  color: #FFFFFF;
}
.login_btn:focus {
  box-shadow: none !important;
  outline: 0px !important;
}
.login_container {
  border-radius: 8px !important;
  height: 29%;
  margin-top:9%;
  /* position: absolute;
  top: 10%; */
}
.input-group-text {
  /* background: #ff8816 !important; */
  color: white !important;
  border: 0 !important;
  border-radius: 0.25rem 0 0 0.25rem !important;
}
.input_user,
.input_pass:focus {
  box-shadow: none !important;
  outline: 0px !important;
}
.custom-checkbox .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #c0392b !important;
}
h3 {
  margin-bottom: 0px;
  text-align: center;
}
.style-form{
  flex-direction: column-reverse;
  height:28%;
  position: relative;
}

/* .style-form::placeholder{
    font-size: 1px;
} */

.hide-password{
  position: absolute;
  top:26%;
  right:8%;
  border: none;
  background: none;
  /* background-color: white !important; */
  font-size: 24px;

    /* height: ; */
}
.style-login{
  font-family: Roboto;
  font-style: normal;
  font-weight: 700;
  font-size: 46px;
  line-height: 140%;
  color: #000000;
}
.login-detail{
  height: 90%;
  width: 80%;
  justify-content: center;
  align-items: center;
}
.image-login{
  height: 19%;
}
.title-inpput{
  font-family: Roboto;
  font-style: normal;
  /* font-weight: 700; */
  font-size: 21px;
  line-height: 140%;
  color: #000000;
}
.custom-input{
  height:100% !important;
}
.input-login{
  height:100% !important;
  width: 100%;
  background: #FFFFFF !important;
  border: 1px solid #E2E8F0;
  box-sizing: border-box;
  border-radius: 8px;
  /* font-size:18px; */
}
.style-form input::placeholder{
  font-size: 18px;
}

.form-login{
  width:100% !important;
  height: 100%;
}
.login-details{
  height:100% !important;
  background-color: black;
}
.login-details .row{
  height: 38.5%;
}
.forgot-password{
  font-family: Roboto !important;
  font-style: normal !important;
  font-weight: 400 !important;
  font-size: 18px !important;
  line-height: 140% !important;
  color: #000000 !important;
  margin-top:2%;
}
.image-forgot{
  height:28.76%;
  margin-bottom:2%;
}
.image-detail{
  height:100%;
  /* width: 100%; */
}
.brand_logo {
  /* margin-top:30%; */
  height: 100%;
  width: 100%;
}
.password-style{
  margin-top:3%;
}
.form-input{
  position: absolute;
  top:60%;
  width: 100%;
  height:94%;
}
.login-style{
  position: absolute;
  top:98%;
  width: 100%;
  height:94%;
}
.logo-login{
  height: 100%;
  width: 100%;
}
.icon-eye-login{
  color: rgb(46, 121, 220);
}
/* RESPONSIVE  */
@media only screen and (max-height: 39.688rem){
  .user_card{
    width: 42%;
  }
}


@media only screen and (min-width:62rem ) and (max-width: 75rem){
  .user_card{
    width: 65%;
    height:85%;
  }
}

@media only screen and (min-width:48rem ) and (max-width: 61.938rem){
  .user_card{
    width: 91%;
    height:73%;
  }
  .login_container{
    margin-top:12%;
  }
}

@media only screen and (max-width: 47.938rem){
  .user_card{
    width: 97%;
  }
}

</style>
